import React from 'react';

const metrics = [
  ['Open Deals', 'Pipeline', 'CRM module', '#38AECC'],
  ['Invoicing', 'Finance', 'Accounting', '#E42613'],
  ['Inventory', 'Stock', 'Multi-site', '#714B67'],
  ['Automations', 'Workflows', 'Integrated', '#017E84'],
];

function MiniSparkline() {
  const points = [16, 22, 19, 28, 24, 34, 31, 42, 39, 51, 58, 54, 67, 74, 82, 88];
  const path = points
    .map((value, index) => {
      const x = (index / (points.length - 1)) * 100;
      const y = 100 - value;
      return `${index === 0 ? 'M' : 'L'} ${x} ${y}`;
    })
    .join(' ');

  return (
    <svg className="odoo-dash__spark" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <path d={`${path} L 100 100 L 0 100 Z`} className="odoo-dash__spark-area" />
      <path d={path} className="odoo-dash__spark-line" />
    </svg>
  );
}

export function OdooDashboardArt() {
  return (
    <div className="odoo-cockpit-art" aria-label="odoo ERP dashboard preview">
      <article className="odoo-dash">
        <header className="odoo-dash__top">
          <div>
            <span />
            <span />
            <span />
          </div>
          <span className="odoo-dash__brand">
            <img src="/odoo_logo.svg" alt="odoo" />
            <strong>ERP workspace</strong>
          </span>
          <em>
            <span />
            Connected modules
          </em>
        </header>

        <section className="odoo-dash__main">
          <div className="odoo-dash__main-head">
            <div>
              <span>Consolidated view</span>
              <h3>
                Operations dashboard
                <em className="odoo-dash__tag">
                  <img src="/odoo_logo.svg" alt="odoo" />
                  ERP
                </em>
              </h3>
            </div>
            <div className="odoo-dash__range">
              {['1W', '1M', '3M', '1Y'].map((range) => (
                <span key={range} className={range === '3M' ? 'is-active' : ''}>
                  {range}
                </span>
              ))}
            </div>
          </div>
          <MiniSparkline />
        </section>

        <section className="odoo-dash__metrics">
          {metrics.map(([label, value, sub, color]) => (
            <article key={label} style={{ '--metric-color': color }}>
              <span>{label}</span>
              <strong>{value}</strong>
              <em>{sub}</em>
            </article>
          ))}
        </section>
      </article>
    </div>
  );
}
